import React from 'react';

const Payment = () => {
  return (
    <div>
      <h1>Payment Method Comming Soon</h1>
    </div>
  );
};

export default Payment;
